module.exports = __webpack_public_path__ + "static/img/preliminary-round-no4.ce42b821.png";